// 公共模块
export const G                                   = {
	blog                                         : '私のブログのバックエンド',
}

export const lang                                = {
	auto                                         : '自動検出',
	zh                                           : '中国語の簡体字',
	tw                                           : '中国語繁体字',
	en                                           : '英語',
	ja                                           : '日本語',
}


// WEBPACK FOOTER //
// ./src/assets/lang/ja.js